import { Header } from "../components/Header"
import { SlCheck } from "react-icons/sl";
import confirmationWallpaper from '../assets/images/confirmationWallpaper.png';
import convidados from '../database/convidados.json';
import { useEffect, useState } from "react";
import { Invite } from "../@types/Invite";

export const Confirmation = () => {

    const [groupInvite, setGroupInvite] = useState<Invite[]>([]);
    const [name, setName] = useState('');
    const [notFound, setNotFound] = useState(false);

    const getConvidados = () => {
        const convidadoProcurado = convidados.find((convidado) => {
            return convidado.name.toLowerCase() === name.toLowerCase(); 
        });

        if(convidadoProcurado){
            const grupoConvidados = convidados.filter((convidado) => {
                return convidado.grupo == convidadoProcurado.grupo;
            })
            setGroupInvite(grupoConvidados);
        }else{
            setNotFound(true);
        }
    }

    useEffect(() => {
        if(name == ''){
            setGroupInvite([]);
            setNotFound(false);
        }
    }, [name]);


    return (
        <>
            <Header />
            <div className="h-64 w-full bg-cover bg-center relative" style={{ backgroundImage: `url(${confirmationWallpaper})` }}>
                <div className="absolute w-full h-full bg-black opacity-50 z-10"></div>
                <div className="relative z-20 h-full flex md:flex-row flex-col items-center justify-center md:gap-8 gap-4">
                    <input onChange={({target}) => setName(target.value.toLocaleLowerCase())} className="rounded-md h-12 w-72 px-3 text-xl poppins-regular"  type="text" placeholder="Digite seu primeiro nome"/>
                    <button onClick={() => getConvidados()} className="rounded-md bg-emerald-900 h-12 w-28 text-white poppins-bold">Pesquisar</button>
                </div>
            </div>
            <div className="py-4">
                <h3 className="amatic-sc-bold text-3xl text-center">Grupo de convidados</h3>
                <p  className="text-center poppins-light">Conto com sua presença</p>
                <ul className="text-center py-4">
                    {groupInvite.map((invited) => (
                        <Invited key={invited.id} name={invited.name} />
                    ))}
                    {notFound && <p>Convidado não encontrado</p>}
                </ul>
            </div>

        </>
    )
}

const Invited = ({name}: {name: string}) => {
    return (
        <li className={` bg-gray-300  w-72 mx-auto mb-2 py-3 rounded-md flex justify-between px-4 items-center gap-3`}>
            <p className="text-xl poppins-regular">{name}</p>
            <div className="flex gap-4 text-2xl bg-white p-3 rounded-md">
                <SlCheck  className='rounded-md bg-emerald-900 text-white  h-10 w-10 px-2' /> 
            </div>
        </li>
    )
}